import { PRESUPUESTADOR_SPECIAL_BONIFICATION_SUCCESS } from '../constants'

export function reducer(state, action) {
    if (action.type === PRESUPUESTADOR_SPECIAL_BONIFICATION_SUCCESS) {
        const bonifMax = state?.nuevo?.precio_local

        const usedCarBonif = state?.entregaUsados.map( car => {
            if (!car?.take_improvement_amount) return 0
            const bonifExtraPercentaje = state?.nuevo?.bonification?.taking_car_percentage
            const takingPrice = ( car.updatedTakePrice || car.original_price || car.auxOriginalPrice || car.appraisal )
        
            const discountNominalValue = Math.floor((Math.floor(takingPrice * bonifExtraPercentaje) / 100) / 1000) * 1000
            const price = car.take_improvement_amount - discountNominalValue
        
            return price <= 0 || !price ? 0 : price
          }).reduce((total, amount) => total + amount, 0)

          const bonificationLimit = bonifMax - usedCarBonif - action.data.value // 20% del precio de venta - bonif de Usados - bonif card Nuevo

        return {
            ...state,
            validateBonificacionVendedorPending: false,
            validateBonificacionVendedorError: null,
            special_discount: action.data.value,
            changeAmount: false,
            bonificationLimit: bonificationLimit > 0 ? bonificationLimit : 0,
        }
    } else {
        return state
    }
}
